import React from 'react';
import './text-input.css';

function TextInput({method}) {
    return (
        <input type="text" className="text-area" onChange={method} />
    );
}

export default TextInput;